import SectionHeading from "@/components/base/SectionHeading";
import Reveal from "@/components/base/Reveal";
import { workflow } from "@/mocks/site";

export default function WorkflowSteps() {
  return (
    <section className="w-full bg-background-50 px-4 py-16 md:px-6 md:py-24">
      <div className="mx-auto w-full">
        <SectionHeading
          align="center"
          eyebrow="投稿流程"
          title="从看到选题到编辑跟进，只要四步"
          desc="整个过程不复杂。你只需要把知道的事情讲清楚，剩下的核实、润色与发布由编辑团队完成。"
        />

        <div className="mt-12 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {workflow.map((item, index) => (
            <Reveal key={item.step} delay={index * 100} className="h-full">
              <article className="relative flex h-full flex-col rounded-lg border border-background-200 bg-background-50 p-5 md:p-6">
                <div className="flex items-center justify-between">
                  <span className="flex h-11 w-11 items-center justify-center rounded-md bg-secondary-100 text-secondary-700">
                    <i className={`${item.icon} text-xl leading-none`}></i>
                  </span>
                  <span className="font-heading text-3xl font-bold text-background-300">{item.step}</span>
                </div>
                <h3 className="mt-5 font-heading text-base font-bold text-foreground-950 md:text-lg">
                  {item.title}
                </h3>
                <p className="mt-2.5 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}